import { render } from "./BotDesigner.vue?vue&type=template&id=39111e66&scoped=true"
import script from "./BotDesigner.vue?vue&type=script&lang=js"
export * from "./BotDesigner.vue?vue&type=script&lang=js"

import "./BotDesigner.vue?vue&type=style&index=0&id=39111e66&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39111e66"]])

export default __exports__